// extracted by mini-css-extract-plugin
export var button = "_g0-4";
export var hasDarkBackground = "_g0-7";
export var hasLightBackground = "_g0-6";
export var iconWrapper = "_g0-0";
export var large = "_g0-2";
export var medium = "_g0-1";
export var small = "_g0-5";
export var xsmall = "_g0-3";